import AuthModalContainer from "./authModalContainer";
import HeadLine from "../headLine";
import CreatePasswordForm from "../createPasswordForm";

const CreatePasswordModal = () => {
  return (
    <AuthModalContainer>
      <HeadLine>برای ایجاد رمزعبور اطلاعات را تکمیل کنید.</HeadLine>
      <CreatePasswordForm />
    </AuthModalContainer>
  );
};

export default CreatePasswordModal;
